var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95 1185 c-25 -24 -25 -25 -25 -223 l0 -199 26 -27 27 -26 197 0 197 0 27 26 26 27 0 197 0 197 -26 27 -27 26 -199 0 c-198 0 -199 0 -223 -25z m395 -225 l0 -170 -170 0 -170 0 0 170 0 170 170 0 170 0 0 -170z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735 1185 c-25 -24 -25 -25 -25 -223 l0 -199 26 -27 27 -26 197 0 197 0 27 26 26 27 0 197 0 197 -26 27 -27 26 -199 0 c-198 0 -199 0 -223 -25z m395 -225 l0 -170 -170 0 -170 0 0 170 0 170 170 0 170 0 0 -170z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 477 c-109 -109 -123 -127 -123 -157 0 -30 14 -48 123 -157 163 -163 151 -163 314 0 109 109 123 127 123 157 0 30 -14 48 -123 157 -109 109 -127 123 -157 123 -30 0 -48 -14 -157 -123z m262 -57 l100 -100 -103 -103 -102 -102 -102 102 -103 103 100 100 c55 55 102 100 105 100 3 0 50 -45 105 -100z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 545 c-25 -24 -25 -25 -25 -223 l0 -199 26 -27 27 -26 197 0 197 0 27 26 26 27 0 197 0 197 -26 27 -27 26 -199 0 c-198 0 -199 0 -223 -25z m395 -225 l0 -170 -170 0 -170 0 0 170 0 170 170 0 170 0 0 -170z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthericon);
export default __webpack_public_path__ + "static/media/othericon.b4350201894bf9da20b3ea2159222c8c.svg";
export { ForwardRef as ReactComponent };